
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/devices",
      function () {
        return require("private-next-pages/[locale]/legal/devices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/devices"])
      });
    }
  